// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_ek-0";
export var headerCellHover = "_ek-1";